import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/people/DonorDirectoryReport.jsx
// — renamed Donor -> Member, endpoint moved to /reports/memberships/member-directory
// (MembershipReportController::memberDirectory()).
const COLUMNS: ReportColumn[] = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'email', label: 'Email' },
  { key: 'mobile', label: 'Mobile' },
  { key: 'gender', label: 'Gender' },
  { key: 'member_type', label: 'Member Type' },
];

export function MemberDirectoryReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Member Directory"
      description="Full member listing with contact details and type."
      endpoint="/reports/memberships/member-directory"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'member_type')}
    />
  );
}
